$( '._script-link' ).on( 'click', function( event ){
    event.preventDefault();
    var href = $( this ).attr( 'data-href' );
    var target = $( this ).attr( 'data-target' );

    if( target === 'blank' ){
        window.open( href );

    }
    else{
        window.location = href;
    }
} );